// extracted by mini-css-extract-plugin
export var circle = "_2m-2";
export var icon = "_2m-a";
export var iconHighlight = "_2m-0";
export var lg = "_2m-8";
export var md = "_2m-7";
export var outline = "_2m-4";
export var sm = "_2m-6";
export var square = "_2m-1";
export var xl = "_2m-9";
export var xs = "_2m-5";
export var xxs = "_2m-3";